import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const UserNotActiveNotification = (props) => {
    const {
        data,
        translate,
    } = props;

    if (utils.isEmpty(data)) {
        return null;
    }

    if (data.enabled) {
        return null;
    }

    return (
        <ErrorMessageField>
            { translate(`resources.products.notifications.inactive`) }
        </ErrorMessageField>
    );
};

UserNotActiveNotification.propTypes = {
    data: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(UserNotActiveNotification);



// WEBPACK FOOTER //
// ./src/components/notifications/ProductNotActiveNotification.js